import React, { lazy, Suspense } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import withAdminLayout from '../../layout/withAdminLayout';
import { Spin } from 'antd';

const Profile = lazy(() => import('../../container/profile/Index'));
const ChangePassword = lazy(() => import('../../container/profile/ChangePassword'));

const ProfileRoutes = () => {

    return (
        <Suspense
            fallback={
                <div className="spin">
                    <Spin />
                </div>
            }
        >
            <Routes>
                <Route path="/" element={<Profile />} />
                <Route path="/change-password" element={<ChangePassword />} />
                <Route path="*" element={<Navigate to="/dashboard" />} />
            </Routes>
        </Suspense>
    )
}

export default withAdminLayout(ProfileRoutes);
